import React, { useEffect, useState, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Tabs,
  Tab,
  Box,
  Divider,
  useTheme,
  useMediaQuery
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import EmployerViewController from "../../redux/actions/EmployerApiAction";
import EmployerInformationForm from "./tabs/EmployerForm";
import EmployerPermissionsTab from "./tabs/PermissionForm";
import MasterViewController from "../../redux/actions/masterApiActions";
import { FadeLoader } from "react-spinners";
import { getUserInfoFromToken } from "../../utils/authUtils";
import defaultPermissionsData from "../../JsonFile/PermisssionJsonfile.json";


function EmployerFormModal({ show, handleClose, initialData = null }) {
  const [userType, setUserType] = useState(null);
  const [userId, setUserId] = useState(null);


  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [permissions, setPermissions] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const dispatch = useDispatch();
  const { addEmployer, updateEmployer } = EmployerViewController();
  const { getPermissionsModules ,} = MasterViewController();
  const { permission_modules } = useSelector((state) => state.master);
  const { isLoding } = useSelector((state) => state.employer);
  const isEdit = Boolean(initialData?.id);

  const [initialValues, setInitialValues] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
    company: ""
  });

  const formikRef = useRef();
    useEffect(() => {
    const { userType, userId } = getUserInfoFromToken();
    setUserType(userType);
    setUserId(userId);
  }, []);
  useEffect(() => {
    if (userType) {
      console.log("userType:", userType, "userId:", userId);
      dispatch(getPermissionsModules(userType));
    }
  }, [dispatch, userType]);

  useEffect(() => {
    if (show && initialData) {
      setInitialValues({
        first_name: initialData.first_name || "",
        last_name: initialData.last_name || "",
        email: initialData.email || "",
        mobile_number: initialData.mobile_number || "",
        company: initialData.company?.id || ""
      });
    } else if (show && !initialData) {
      setInitialValues({
        first_name: "",
        last_name: "",
        email: "",
        mobile_number: "",
        company: ""
      });
    }
  }, [show, initialData]);

  useEffect(() => {
    if (show) {
      if (initialData?.permissions?.permissions?.length) {
        const clearedPermissions = permission_modules.map((mod) => {
          const row = {
            module: mod.key,
            moduleLabel: mod.label,
            enabled: false
          };
          mod.actions.forEach((act) => {
            row[act.key] = false;
          });
          return row;
        });
        setPermissions(clearedPermissions);
        const patchedData = clearedPermissions.map((masterItem) => {
          const incomingItem = initialData.permissions.permissions.find(
            (i) => i.module === masterItem.module
          );

          if (incomingItem) {
            return {
              ...masterItem,
              ...incomingItem // overwrites values from incoming
            };
          }

          return masterItem; // unchanged if not found in incoming
        });

        // Edit Mode: use existing permissions
        setPermissions(patchedData);
      } else if (permission_modules?.length) {
    // Add Mode: patch default permissions from JSON
    const clearedPermissions = permission_modules.map((mod) => {
      const defaultItem =
        defaultPermissionsData.permissions.employer.find(
          (p) => p.module === mod.key
        ) || {};

      const row = {
        module: mod.key,
        moduleLabel: mod.label,
        enabled: defaultItem.enabled || false,
      };

      mod.actions.forEach((act) => {
        row[act.key] = defaultItem[act.key] ?? false; // patch from JSON if exists, else false
      });

      return row;
    });

    setPermissions(clearedPermissions);
}

    }
  }, [show, initialData, permission_modules]);

  const validationSchema = Yup.object({
    first_name: Yup.string().required("First name is required"),
    last_name: Yup.string().required("Last name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    mobile_number: Yup.string()
      .matches(/^[0-9]{10}$/, "Invalid phone number")
      .required("Phone number is required"),
    company: Yup.string().required("Company is required")
  });

  const handleSubmit = (values, { resetForm }) => {
    const payload = {
      ...values,
      company: Number(values.company),
      permissions: { permissions }
    };

    const action = isEdit
      ? updateEmployer(initialData.id, payload)
      : addEmployer(payload);

    dispatch(action)
      .then(() => {
        resetForm();
        handleClose();
        setTabIndex(0);
      })
      .catch((err) => console.error("Submission error:", err));
  };

  const handleNext = async () => {
    if (!formikRef.current) return;

    const errors = await formikRef.current.validateForm();
    formikRef.current.setTouched({
      first_name: true,
      last_name: true,
      email: true,
      mobile_number: true,
      company: true
    });

    if (Object.keys(errors).length === 0) {
      setTabIndex(1);
    }
  };

  const handleTabChange = async (event, newIndex) => {
    if (newIndex === 1 && formikRef.current) {
      const errors = await formikRef.current.validateForm();
      formikRef.current.setTouched({
        first_name: true,
        last_name: true,
        email: true,
        mobile_number: true,
        company: true
      });
      if (Object.keys(errors).length === 0) {
        setTabIndex(newIndex);
      }
    } else {
      setTabIndex(newIndex);
    }
  };

  return (
    <Dialog
      sx={{
      height:'100%',
      width: '100%',
      maxWidth: 'none',
      maxHeight: 'none',
      margin: 0,
    }}
      open={show}
      onClose={handleClose}
      fullScreen
      // fullWidth={!isMobile}
      // maxWidth={isMobile ? false : "md"}
      // PaperProps={{
      //   sx: {
      //     height: "100% !important",
      //     width: "100% !important",
      //     maxWidth: "none !important",
      //     borderRadius: 2,
      //     flexDirection: "column"
      //     // ...(isMobile && {
      //     //   width: "95vw",
      //     //   maxWidth: "95vw",
      //     //   m: 1
      //     // })
      //   }
      // }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        {isEdit ? "Edit Employer" : "Add Employer"}
      </DialogTitle>
      <Divider />
      <Box sx={{ px: 3, pt: 1 }}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab label="Basic Information" />
          <Tab label="Permissions" />
        </Tabs>
      </Box>

      <DialogContent dividers sx={{ flexGrow: 1, overflowY: "auto" }}>
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {(formikProps) => (
            <Form>
              <Box mt={2}>
                {tabIndex === 0 && (
                  <EmployerInformationForm formik={formikProps} />
                )}
                {tabIndex === 1 && (
                  <EmployerPermissionsTab
                    formik={formikProps}
                    modulesData={permission_modules}
                    permissions={permissions}
                    setPermissions={setPermissions}
                  />
                )}
              </Box>
            </Form>
          )}
        </Formik>
      </DialogContent>

      {/* Footer */}
      <Box
        sx={{
          position: "sticky", // Makes it sticky
          bottom: 0, // Sticks to bottom
          backgroundColor: "background.paper", // Matches theme background
          zIndex: 1000, // Keeps it above content
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          px: 3,
          py: 2,
          borderTop: 1,
          borderColor: "divider"
        }}
      >
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Box sx={{ flexGrow: 1 }} />
        {/* Always show Back button, but disable on tabIndex 0 */}
        <Button
          disabled={tabIndex === 0}
          onClick={() => setTabIndex((prev) => prev - 1)}
        >
          Back
        </Button>

        {/* Show Next or Submit depending on tab */}
        {tabIndex < 1 ? (
          <Button variant="contained" onClick={handleNext}>
            Next
          </Button>
        ) : (
          <Button
            variant="contained"
            onClick={() => {
              if (formikRef.current) {
                formikRef.current.handleSubmit();
              }
            }}
          >
            {isEdit ? "Update" : "Submit"}
          </Button>
        )}
      </Box>

      {isLoding && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(255, 255, 255, 0.6)",
            zIndex: 9999
          }}
        >
          <div
            style={{
              background:
                "linear-gradient(45deg,rgb(65, 63, 63),rgb(238, 231, 238))",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }}
          >
            <FadeLoader
              // color={"#f27121"} // fallback color, not used with gradient
              loading={true}
              size={150}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        </div>
      )}
    </Dialog>
  );
}

export default EmployerFormModal;
